import { useMemo } from 'react';

export const useGetMenuItemsAccess = ({
  isLightReachAdmin,
  isOrgAccountingAdmin,
  enablePayouts,
  isLightReachAccountingAdmin,
  isLightReachEPCAccountingAdmin,
  isLightReachAccountingReader,
  isLightReachAccountingSettings,
  isTaskAdmin,
  isHvacOrWaterHeater,
  onPointIsPrimaryWarrantyProvider,
}: {
  isLightReachAdmin: boolean;
  isOrgAccountingAdmin: boolean;
  enablePayouts: boolean;
  isLightReachAccountingAdmin: boolean;
  isLightReachEPCAccountingAdmin: boolean;
  isLightReachAccountingReader: boolean;
  isLightReachAccountingSettings: boolean;
  isTaskAdmin: boolean;
  isHvacOrWaterHeater: boolean;
  onPointIsPrimaryWarrantyProvider: boolean;
}) => {
  return useMemo(() => {
    const adminDashboardAccess = isLightReachAdmin;
    const epcDashboardAccess = isOrgAccountingAdmin;
    const adminPayoutsAccess =
      enablePayouts &&
      (isLightReachAccountingAdmin ||
        isLightReachEPCAccountingAdmin ||
        isLightReachAccountingReader ||
        isLightReachAccountingSettings);
    const epcPayoutsAccess = enablePayouts && isOrgAccountingAdmin;
    const onPointClaimFormAccess = isHvacOrWaterHeater && onPointIsPrimaryWarrantyProvider;

    return {
      dashboardAccess: adminDashboardAccess || epcDashboardAccess,
      payoutsAccess: adminPayoutsAccess || epcPayoutsAccess,
      adminDashboardAccess,
      epcDashboardAccess,
      adminPayoutsAccess,
      epcPayoutsAccess,
      adminTaskAccess: isTaskAdmin,
      onPointClaimFormAccess,
    };
  }, [
    isLightReachAdmin,
    isOrgAccountingAdmin,
    enablePayouts,
    isLightReachAccountingAdmin,
    isLightReachEPCAccountingAdmin,
    isLightReachAccountingReader,
    isLightReachAccountingSettings,
    isTaskAdmin,
    isHvacOrWaterHeater,
    onPointIsPrimaryWarrantyProvider,
  ]);
};
